import { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Alert, Button, Card, CardBody, Form, FormGroup, Input, Label, Spinner } from 'reactstrap';
import { useAuth } from '../auth/useAuth.js';

export function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    setBusy(true);
    setError(null);

    try {
      await login(email, password);
      navigate(location.state?.from?.pathname ?? '/', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="mx-auto" style={{ maxWidth: 420 }}>
      <h1 className="h3 mb-3">Sign in</h1>
      <Card>
        <CardBody>
          <Form onSubmit={handleSubmit}>
            {error && <Alert fade={false} color="danger">{error}</Alert>}

            <FormGroup>
              <Label for="email">Email</Label>
              <Input id="email" type="email" value={email} autoComplete="username"
                onChange={(e) => setEmail(e.target.value)} required />
            </FormGroup>

            <FormGroup>
              <Label for="password">Password</Label>
              <Input id="password" type="password" value={password} autoComplete="current-password"
                onChange={(e) => setPassword(e.target.value)} required />
            </FormGroup>

            <Button color="primary" type="submit" disabled={busy} className="w-100">
              {busy ? <Spinner size="sm" /> : 'Sign in'}
            </Button>
          </Form>
        </CardBody>
      </Card>
      <p className="text-muted mt-3 small">
        Have an invite code? <Link to="/register">Create an account</Link>.
      </p>
    </div>
  );
}
